import React from "react"
import { AppCardTitle, AppCrudTable, AppResultsSkeleton } from "@components"
import { useProviderSuppliersMappingTableData } from "Pages/Admin/ProvidersSuppliersMapping/@hooks"
import { capitalize } from "@mui/material"
import { normalizedDataColumn, rawDataColumn } from "Pages/Admin/ProvidersSuppliersMapping/Table/@columns"
import MultiProvidersSuppliersMappingTableToolbar from "Pages/Admin/ProvidersSuppliersMapping/Table/MultiToolbar"

export default function ProvidersSuppliersMappingTable({ type = 'providers' }) {
	const { data, isLoading } = useProviderSuppliersMappingTableData(type)


	return isLoading
		? <AppResultsSkeleton/>
		: <AppCrudTable
			title={<AppCardTitle icon="shuffle" title={`${type === 'providers' ? capitalize(type) : 'Web Suppliers'} Mapping data`}/>}
			data={data}
			columns={[rawDataColumn(), normalizedDataColumn()]}
			options={{
				selectableRows: 'multiple',
				customToolbarSelect: (selectedData, setSelectedRows) => <MultiProvidersSuppliersMappingTableToolbar
					type={type}
					selectedData={selectedData}
					setSelectedRows={setSelectedRows}/>,
				tableBodyHeight: "600",
				search: true,
			}}
		/>
}